import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/Button';
import { useTheme } from '../hooks/useTheme';

export const ThemeToggle: React.FC<{ language?: 'es' | 'en' }> = ({ language = 'es' }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const label = language === 'es'
    ? `Cambiar a tema ${isDarkMode ? 'claro' : 'oscuro'}`
    : `Switch to ${isDarkMode ? 'light' : 'dark'} theme`;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
    </Button>
  );
};
